import { apiSlice } from "../store/api-base-slice";
import { API_ENDPOINTS_ROUTES } from "../constants/routes";
import {
  DownloadHistoryRequest,
  DownloadHistoryResponse,
  GetHistoryResponse,
} from "../sharedTypes/history-types";

const getHistoryUrl = (name: string) => {
  switch (name) {
    case "reports":
      return API_ENDPOINTS_ROUTES.REPORTS_GET_REPORTS;
    case "transactions":
      return API_ENDPOINTS_ROUTES.WALLETS_GET_TRANSACTIONS;
    default:
      return "";
  }
};
const getDownloadHistoryUrl = (name: string) => {
  switch (name) {
    case "reports":
      return API_ENDPOINTS_ROUTES.DOWNLOAD_REPORTS;
    case "transactions":
      return API_ENDPOINTS_ROUTES.DOWNLOAD_TRANSACTIONS;
    default:
      return "";
  }
};

export const historyApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getHistory: builder.query<
      GetHistoryResponse,
      {
        name?: string;
        startDate?: string;
        endDate?: string;
        search?: string;
        status?: string;
        pageNumber?: string;
        pageSize?: string;
        responseStatus?: string;
        transactionDirection?:string;
      }
    >({
      query: (params) => ({
        url: getHistoryUrl(params.name ?? ""),
        method: "GET",
        params: { ...params },
      }),
    }),
    getDownloadHistory: builder.query<
      DownloadHistoryResponse,
      DownloadHistoryRequest
    >({
      query: (params) => ({
        url: getDownloadHistoryUrl(params?.name),
        method: "GET",
        params: { ...params },
      }),
    }),
  }),
});

export const { useGetHistoryQuery, useLazyGetDownloadHistoryQuery } = historyApiSlice;
